import clsx from "clsx";
import Spinner from "./spinner";

interface IconProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  icon?: any;
  loading?: boolean;
}
export default function IconButton({
  icon,
  type = "submit",
  className,
  label,
  loading = false,
  ...rest
}: IconProps) {
  const Icon = icon;
  return (
    <button
      {...rest}
      type={type}
      className={clsx("rounded-md border p-2 hover:bg-gray-100", className)}
    >
      <span className="sr-only">{label}</span>
      {loading ? (
        <Spinner size="small" visible={true}></Spinner>
      ) : (
        <Icon className="w-5" />
      )}
    </button>
  );
}
